import * as angular from 'angular';
import { Constants as constants } from '@constants/shared';
import { FeesRepo as feesRepo } from '@services/fees.repo';
import { fees } from './fees';
import {feeTypeManagement} from './feeTypeManagement/fees.feetype.management'
import {addFeeTypeDialog} from './feeTypeManagement/addFeeTypeDialog/addFeeType.dialog'
import {feeTypeForm} from './feeTypeManagement/feeTypeForm/feeType.form'
import {clientFeeManagement} from './clientFeeManagement/fees.clientFeeManagement'
import {createPortfolioFeeDialog} from './clientFeeManagement/createPortfolioFeeDialog/createPortfolioFee.dialog'
import {createPortfolioFeeExclusionDialog} from './clientFeeManagement/createFeeExclusion/createPortfolioFeeExclusion.dialog'
import {editPortfolioFeeExclusionDialog} from './clientFeeManagement/editFeeExclusion/editPortfolioFeeExclusion.dialog'
import {managementFeeCashAccount} from './cashAccounts/fees.cashaccounts'
import {instructions} from './instructions/fees.instructions'
import {tempRun} from './instructions/temprun/fees.instructions.temprun'
import {finalRun} from './instructions/finalrun/fees.instructions.finalrun'
import {generateInstructionSheetDialog} from  './instructions/finalrun/generateInstructionSheetDialog/instruction.generateInstructionSheet.dialog'
import {instructionSheet} from './instructions/instructionSheets/fees.instructions.sheets'
import {sharedSearch} from './instructions/shared-search/fees.instructions.shared-search'
import {FeeCardsComponent} from './feeCards/feeCards'
import {DebitAccountsComponent} from './debitAccounts/debitAccounts'
import {editDebitAccountDialog} from './debitAccounts/editDebitAccount.dialog'
import {ExclusionsComponent} from './exclusions/exclusions'
import {feeTypeFees} from './fees-components/fee-type-fees/fee-type-fees'
import {clientFees} from './fees-components/client-fees/client-fees'
import {portfolioFees} from './fees-components/portfolio-fees/portfolio-fees'
import {individualFeesAuditing} from './fees-components/individual-fees-auditing/individual-fees-auditing'
import {feesRecalculation} from './fees-components/fees-recalculation/fees-recalculation'
import {navFeesSummary} from './fees-components/nav-fees-summary/nav-fees-summary'
import {fullClientListSummary} from './fees-components/full-client-list-summary/full-client-list-summary'
import {activitySummary} from './fees-components/activity-summary/activity-summary';
import {activityDetailTable} from './fees-components/activity-detail-table/activity-detail-table';
import {activityDashboard} from './fees-components/activity-dashboard/activity-dashboard';
export const feesModule = 'fees';

angular
  .module(feesModule, ['xeditable'])
  .constant("config", constants.Default)
  .service('feesRepo', feesRepo)
  .component('fees', fees)
  .component('feeTypeManagement',feeTypeManagement)
  .component('addFeeTypeDialog',addFeeTypeDialog)
  .component('feeTypeForm', feeTypeForm)
  .component('clientFeeManagement',clientFeeManagement)
  .component('createPortfolioFeeDialog',createPortfolioFeeDialog)
  .component('createPortfolioFeeExclusionDialog',createPortfolioFeeExclusionDialog)
  .component('editPortfolioFeeExclusionDialog',editPortfolioFeeExclusionDialog)
  .component('managementFeeCashAccount' , managementFeeCashAccount)
  .component('instructions', instructions)
  .component('tempRun',tempRun)
  .component('finalRun', finalRun)
  .component('generateInstructionSheetDialog',generateInstructionSheetDialog)
  .component('instructionSheet', instructionSheet)
  .component('sharedSearch', sharedSearch)
  .component('feeCards', FeeCardsComponent)
  .component('debitAccounts', DebitAccountsComponent)
  .component('editDebitAccountDialog', editDebitAccountDialog)
  .component('exclusions', ExclusionsComponent)
  .component('feeTypeFees', feeTypeFees)
  .component('clientFees', clientFees)
  .component('portfolioFees', portfolioFees)
  .component('individualFeesAuditing', individualFeesAuditing)
  .component('feesRecalculation', feesRecalculation)
  .component('navFeesSummary', navFeesSummary)
  .component('fullClientListSummary', fullClientListSummary)
  .component('activitySummary', activitySummary)
  .component('activityDetailTable', activityDetailTable)
  .component('activityDashboard', activityDashboard)



// WEBPACK FOOTER //
// ./src/app/fees/fees.index.ts